document.addEventListener('turbolinks:load', function () {

  const whiteLabelConfigDiv = document.getElementById('white-label-config');
  
  // Get values from data-* attributes
  const allowed = whiteLabelConfigDiv.getAttribute('data-allowed');

  // Use these values to change CSS variables or styles
  if(allowed == 'true'){
    const buttonBg = whiteLabelConfigDiv.getAttribute('data-button-bg');
    const textColorRc = whiteLabelConfigDiv.getAttribute('data-text-color-rc');
    document.documentElement.style.setProperty('--button-bg', buttonBg);
    document.documentElement.style.setProperty('--text-color-rc', textColorRc);
  }

  const navbarColorInput = document.getElementById('nav_color');
  const navbarCustomColor = document.getElementById('navbar_custom_color');
  const buttonColorInput = document.getElementById('button_color');
  const buttonCustomColor = document.getElementById('button_custom_color');
  const textColorInput = document.getElementById('text_color');
  const textCustomColor = document.getElementById('text_custom_color');

  const newStepColorInput = document.getElementById('new_step_color');
  const newStepCustomColor = document.getElementById('new_step_custom_color');

  const editedStepColorInput = document.getElementById('edited_step_color');
  const editedStepCustomColor = document.getElementById('edited_step_custom_color');

  const newStepBlockColorInput = document.getElementById('new_step_block_color');
  const newStepBlockCustomColor = document.getElementById('new_step_block_custom_color');

  // Initialize custom picker colors if the elements exist
  if (navbarCustomColor && navbarColorInput) {
    navbarCustomColor.style.backgroundColor = navbarColorInput.value;
  }

  if (buttonCustomColor && buttonColorInput) {
    buttonCustomColor.style.backgroundColor = buttonColorInput.value;
  }

  if (textCustomColor && textColorInput) {
    textCustomColor.style.backgroundColor = textColorInput.value;
  }

  if (newStepCustomColor && newStepColorInput) {
    newStepCustomColor.style.backgroundColor = newStepColorInput.value;
  }

  if (editedStepCustomColor && editedStepColorInput) {
    editedStepCustomColor.style.backgroundColor = editedStepColorInput.value;
  }

  if (newStepBlockCustomColor && newStepBlockColorInput) {
    newStepBlockCustomColor.style.backgroundColor = newStepBlockColorInput.value;
  }

  // Sync custom picker with native color picker
  if (navbarColorInput) {
    navbarColorInput.addEventListener('input', function () {
      if (navbarCustomColor) {
        navbarCustomColor.style.backgroundColor = this.value;
      }
    });
  }

  if (buttonColorInput) {
    buttonColorInput.addEventListener('input', function () {
      if (buttonCustomColor) {
        buttonCustomColor.style.backgroundColor = this.value;
      }
    });
  }

  if (textColorInput) {
    textColorInput.addEventListener('input', function () {
      if (textCustomColor) {
        textCustomColor.style.backgroundColor = this.value;
      }
    });
  }

  if (newStepColorInput) {
    newStepColorInput.addEventListener('input', function () {
      if (newStepCustomColor) {
        newStepCustomColor.style.backgroundColor = this.value;
      }
    });
  }

  if (editedStepColorInput) {
    editedStepColorInput.addEventListener('input', function () {
      if (editedStepCustomColor) {
        editedStepCustomColor.style.backgroundColor = this.value;
      }
    });
  }

  if (newStepBlockColorInput) {
    newStepBlockColorInput.addEventListener('input', function () {
      if (newStepBlockCustomColor) {
        newStepBlockCustomColor.style.backgroundColor = this.value;
      }
    });
  }

  // Trigger native color picker when clicking on custom picker
  if (navbarCustomColor) {
    navbarCustomColor.addEventListener('click', function () {
      navbarColorInput && navbarColorInput.click();
    });
  }

  if (buttonCustomColor) {
    buttonCustomColor.addEventListener('click', function () {
      buttonColorInput && buttonColorInput.click();
    });
  }

  if (textCustomColor) {
    textCustomColor.addEventListener('click', function () {
      textColorInput && textColorInput.click();
    });
  }

  if (newStepCustomColor) {
    newStepCustomColor.addEventListener('click', function () {
      newStepColorInput && newStepColorInput.click();
    });
  }

  if (editedStepCustomColor) {
    editedStepCustomColor.addEventListener('click', function () {
      editedStepColorInput && editedStepColorInput.click();
    });
  }

  if (newStepBlockCustomColor) {
    newStepBlockCustomColor.addEventListener('click', function () {
      newStepBlockColorInput && newStepBlockColorInput.click();
    });
  }
});

function resetPreference(currentPreferenceId, accountId) {
  const csrfToken = document.querySelector('meta[name="csrf-token"]').content;

  fetch(`/${accountId}/preferences/${currentPreferenceId}/reset_preference`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      'X-CSRF-Token': csrfToken,
    },
    body: JSON.stringify({}),
  })
    .then(response => {
      if (!response.ok) throw new Error('Network response was not ok');
      return response.json();
    })
    .then(data => {
      updateUI(data);
      location.reload();
    })
    .catch(error => console.error("Something went wrong", error));
}

// Function to update the UI based on the response
function updateUI(data) {
  const preferenceElement = document.getElementById("app-top");
  const buttonSelectors = [
    '.btn',
    '.button',
    'button',
    '[type="button"]',
    '[type="reset"]',
    '[type="submit"]',
  ].join(', ');

  // Update preference element background color
  if (preferenceElement) {
    const navbarCustomColor = document.getElementById('navbar_custom_color');
    navbarCustomColor.style.backgroundColor = data.preference.navbar_color;
    preferenceElement.style.backgroundColor = data.preference.navbar_color;
  }

  // Update button colors
  const buttons = document.querySelectorAll(buttonSelectors);
  const buttonCustomColor = document.getElementById('button_custom_color');

  buttonCustomColor.style.backgroundColor = data.preference.button_color;
  buttons.forEach(button => {
    button.style.background = data.preference.button_color;
  });

  const newStepCustomColor = document.getElementById('new_step_custom_color');
  const editedStepCustomColor = document.getElementById('edited_step_custom_color');
  const newStepBlockCustomColor = document.getElementById('new_step_block_custom_color');

  newStepCustomColor.style.backgroundColor = data.preference.new_step_color;
  editedStepCustomColor.style.backgroundColor = data.preference.edited_step_color;
  newStepBlockCustomColor.style.backgroundColor = data.preference.new_step_block_color;
}

// Attach the resetPreference function to the global scope
window.resetPreference = resetPreference;
